// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"1ed3fff2","366":"e0b58c3b","373":"e5b2edd7","712":"58b7db09","858":"29720a55","861":"d8cb1cf6","862":"4dc06879","989":"4a9a59b4"}[chunkId] + ".chunk.js";
};